import styled from 'styled-components';

export const Text = styled.span`
  font-size: ${({ size }) => size};
  color: ${({ color }) => color};
  text-decoration: ${({lineThrough}) =>
    lineThrough ? 'line-through' : 'none'};
  font-weight: ${({ bold }) => bold};
`;
